"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Note = function (_BaseClass) {
  _inherits(Note, _BaseClass);

  /**
   * NoteId der Bemerkung
   * @type {string}
   */

  /**
   * CustomerId des Kunden zu dem die Bemerkung gehört
   * @type {string}
   */

  /**
   * Die Bemerkung
   * @type {string}
   */
  function Note() {
    _classCallCheck(this, Note);

    var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this));

    _this.NoteId = "";
    _this.CustomerId = "";
    _this.Text = "";
    _this.Date = "";
    return _this;
  }
  /**
   * Anlagedatum der Bemerkung
   * @type {date}
   */


  return Note;
}(_BaseClass3.default);

exports.default = Note;